import type { FC, ReactElement } from 'react'
import { useState } from 'react'

import { Input } from '@skytech/ui'
import { Button } from '@skytech/ui/Button'
import type { FieldProps } from 'formik'
import { Field } from 'formik'
import EyeOffIcon from 'mdi-react/EyeOffOutlineIcon'
import EyeIcon from 'mdi-react/EyeOutlineIcon'

import { useTranslation } from '@/app/translations/translations-hooks'

type Props = {
  name?: string
  label?: string | ReactElement
}

const PasswordForm: FC<Props> = ({ name = 'password', label }) => {
  const translate = useTranslation()

  const [isPasswordVisible, setIsPasswordVisible] = useState(false)

  return (
    <Field name={name}>
      {({ field, meta }: FieldProps) => (
        <Input
          isFullWidth
          capitalizeLabel
          id={name}
          type={isPasswordVisible ? 'text' : 'password'}
          ariaLabel={translate('Password')}
          marginBottom={16}
          error={meta.error}
          label={label}
          touched={meta.touched}
          placeholder={translate('Enter your password')}
          RightElement={
            isPasswordVisible ? (
              <Button
                className="m-0 border-none bg-transparent p-0 text-gray-600 shadow-none hover:text-gray-700"
                onClick={() => setIsPasswordVisible(false)}
                Icon={<EyeOffIcon className="w-6" />}
              />
            ) : (
              <Button
                className="m-0 border-none bg-transparent p-0 text-gray-600 shadow-none hover:text-gray-700"
                onClick={() => setIsPasswordVisible(true)}
                Icon={<EyeIcon className="w-6" />}
              />
            )
          }
          {...field}
        />
      )}
    </Field>
  )
}

export default PasswordForm
